import React from "react";

const ApplicationIndicationItem = ({label, url, img}) => {
    return (
        <div className="application-indication-item">
            <a href={url}><img src={img} alt={label} /></a>
            <a href={url}><strong>{label}</strong></a>
        </div>
    );
};

export default ApplicationIndicationItem;
